document.addEventListener('DOMContentLoaded', function () {
  const loadMoreButton = document.getElementById('load-more-button');

  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function () {
      const nextUrl = loadMoreButton.getAttribute('data-next-url');

      if (nextUrl) {
        fetch(nextUrl)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newProducts = doc.querySelector(".product-list__inner").innerHTML;
            const newNextUrl = doc.querySelector('#load-more-button')?.getAttribute('data-next-url');

            // Append new products to the product list
            const productListInner = document.querySelector(".product-list__inner");
            productListInner.insertAdjacentHTML('beforeend', newProducts);

            // Add the "reveal" attribute and apply fade-in effect
            const newProductItems = productListInner.querySelectorAll('product-item:not([style="opacity: 1;"])');
            newProductItems.forEach(item => {
                item.setAttribute('reveal', '');
                item.style.opacity = '0'; // Ensure opacity starts at 0
                item.style.transform = 'translateY(30px)'; // Start with a slight downward transform
                item.style.transition = 'opacity 0.6s ease, transform 0.6s ease'; // Add smooth transition for both opacity and transform
  
                // Trigger the animation after a small delay
                requestAnimationFrame(() => {
                  requestAnimationFrame(() => {
                    item.style.opacity = '1'; // Trigger fade-in
                    item.style.transform = 'translateY(0)'; // Reset transform to original position
                  });
                });
              });

            // Update or remove the "Load More" button
            if (newNextUrl) {
              loadMoreButton.setAttribute('data-next-url', newNextUrl);
            } else {
              loadMoreButton.remove();
            }
          })
          .catch(error => console.error('Error loading more products:', error));
      }
    });
  }
});